import PARTIES from "@/data/parties.yml";
import dynamicLocalization from "@/mixins/dynamic-localization";

export default {
  mixins: [dynamicLocalization],
  props: {
    displayIds: {
      type: Array,
      optional: true,
    },
  },
  data() {
    return {
      PARTIES,
    };
  },
};
